export enum enumAddressType {
    addrTypeUnknown     = 0,
	addrTypeOffice      = 1,
	addrTypeHome        = 2,
	addrTypeRentalLoc   = 3,
	addrTypeLocal       = 4,
	addrTypeDelivery    = 5,
	addrTypeCollection  = 7,
	addrTypeBusiness    = 11,
	addrTypeHQ          = 15,
	addrTypeBillingCo   = 16,
	addrTypePostal      = 18,
	addrTypeStreet      = 20,
	addrTypeBilling     = 24
}

export class Address {
    public addressId: number;
    public addressTypeId: enumAddressType;
    public addressLine1: string;
    public city: string;
    public state: string;
    public zipCode: string;
}